import { render, staticRenderFns } from "./ImportConflictSettingsModal.vue?vue&type=template&id=36e4e25e&"
import script from "./ImportConflictSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ImportConflictSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports